import { NgModule, inject } from '@angular/core';
import {
  DeclarativeFormsModule,
  NextDeclarativeFormsUiModule,
} from '@app/next/declarative-forms/declarative-forms.module';
import { NextFormFeaturesModule } from '@app/next/forms/features/next-form-features.module';
import { provideDeclarativeFormsGeolocationFeature } from '@fmnts/declarative-forms/geolocation';
import { NoopGeolocationService } from './noop-geolocation.service';

@NgModule({
  imports: [
    DeclarativeFormsModule,
    NextDeclarativeFormsUiModule,
    NextFormFeaturesModule,
  ],
  exports: [NextDeclarativeFormsUiModule],
  providers: [
    provideDeclarativeFormsGeolocationFeature({
      geolocation: () => inject(NoopGeolocationService),
    }),
  ],
})
export class SelfCheckoutDeclarativeFormsModule {}
